import { render, staticRenderFns } from "./SampleTypeAdd.vue?vue&type=template&id=35765204"
import script from "./SampleTypeAdd.vue?vue&type=script&lang=js"
export * from "./SampleTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports